import React, { useState } from "react";
import { useFormik } from 'formik';
import { useHistory } from 'react-router';
import InputField from "./formfield/InputField";
import service from "../services/anagrafica/Accessoutenteservice";
import config from '../config';
import Storage from './utils/Storage';
import Translate from "./Translate";
import { useLiveQuery } from "dexie-react-hooks";
import db from "../db";

function LoginForm({ onChangeToRecupera }) {
    const [msg, setMsg] = useState(null);

    let history = useHistory();
    const onLoginSuccess = response => {
        //memorizza la risposta nello storage
        const { access_token, ...rData } = response.data;
        window.access_token = access_token;
        Object.keys(rData).forEach(k => Storage.setItem(k, response.data[k]));
        const pathname = response.data.readonly ? '/materialematrec' : '/progetto';
        if (window.location.pathname !== pathname) {
            history.push(pathname);
        }
        window.location.reload();
    }

    const onLoginFailed = () => {
        setMsg(<Translate key="LOGINFAILED" chiave="LOGINFAILED" pacchetto="Login" />);
    }
    const langs = useLiveQuery(() => db.lingue.toArray());


    const formik = useFormik({
        enableReinitialize: true,
        initialValues: {
            username: '',
            password: '',
        },

        onSubmit: v => {
            if (!v.username || !v.password) {
                setMsg(<Translate key="LOGINEMPTY" chiave="LOGINEMPTY" pacchetto="Login" />);
            } else {
                const values = { ...v };
                if (langs && langs.length !== 0) {
                    values.linguaId = langs[0].id;
                }
                values.grant_type = 'password';
                values.client_id = config.backend.client_id;
                values.client_secret = config.backend.client_secret;
                setMsg(<Translate key="LOGINPROGRESS" chiave="LOGINPROGRESS" pacchetto="Login" />);
                service.login(values).then(onLoginSuccess).catch(onLoginFailed);
            }
        },
    });
    return (
        <form onSubmit={formik.handleSubmit} style={{
            padding: '4rem 4rem 3rem 4rem',
        }}>
            <div className="d-flex justify-content-between flex-column" style={{ height: '25rem' }}>
                <div>
                    <div className="">
                        <h1 className="h1 text-center text-grigioch">LOGIN</h1>
                        <div>
                            <div>{msg || '\u00A0'}</div>
                        </div>
                    </div>
                    <div className="mt-5">
                        <InputField
                            className="bg-grigioch loginbox"
                            labelprops={{
                                duepunti: false,
                                style: { display: 'block' }
                            }}
                            autoFocus={true}
                            onKeyPress={() => setMsg(null)}
                            name="username"
                            label={<Translate chiave="USERNAME" pacchetto="Login" />}
                            value={formik.values.username}
                            onChange={v => formik.setFieldValue('username', v.value)}
                        />
                    </div>
                    <div className="mt-5">
                        <InputField
                            labelprops={{
                                duepunti: false,
                                style: { display: 'block' }
                            }}
                            className="bg-grigioch loginbox"
                            onKeyPress={() => setMsg(null)}
                            name="psw"
                            type="password"
                            label={<Translate chiave="PSW" pacchetto="Login" />}
                            value={formik.values.password}
                            onChange={v => formik.setFieldValue('password', v.value)}
                        />
                    </div>
                </div>
                <div>
                    <div className="d-flex justify-content-between">
                        <div>
                            <button
                                onClick={onChangeToRecupera}
                                type="button"
                                className="btn pt-0 pb-0 rotondo font-weight-semibold loginBtn"
                            ><Translate chiave="RECUPEROPSW" pacchetto="Login" /></button>
                        </div>
                        <div>
                            <input type="submit"
                                className="btn btn-primary  rotondo text-primary p-1 font-weight-semibold loginBtn"
                                value="LOGIN"
                            />
                        </div>
                    </div>
                </div>
            </div>
        </form>
    );
}

export default LoginForm;